import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {change, Field, reduxForm} from 'redux-form';
import {connect} from "react-redux";
import {compose} from "recompose";
import {SelectInput} from 'admin-on-rest';

/**
 * A form containing a SelectInput component with Mode choices
 *
 */
class ConfigurationModeToggleForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mode: 'live'
        };
        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    componentDidMount() {
        const mode = localStorage.getItem('mode');
        this.setState({
            mode: mode
        });
        this.props.dispatch(change('modeForm', 'modeSelect', mode));
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.mode !== this.props.mode) {
            this.setState({
                mode: nextProps.mode
            });
            this.props.dispatch(change('modeForm', 'modeSelect', nextProps.mode));
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.mode !== this.props.mode) {
            localStorage.setItem('mode', this.props.mode);
        }
    }

    handleSelectChange(event, index, value) {
        if (index && index !== value) {
            this.setState({
                mode: index
            });
            this.props.dispatch(change('modeForm', 'modeSelect', index));
        }
    }

    render() {
        const styles = {
            break: {display: 'block', width: '100%', height: 0, border: 'none', margin: 0, paddingBottom: '1em'},
        };

        return (
            <form>
                <div>
                    <Field name="modeSelect"
                           component={SelectInput}
                           value={this.state.mode}
                           onChange={this.handleSelectChange}
                           choices={[
                               {id: 'test', name: 'Test Mode'},
                               {id: 'live', name: 'Live Mode'}
                           ]}
                    />
                    <hr style={styles.break}/>
                </div>
            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['modeForm'];
    if (form && form.values) {
        const selectValue = (form.values['modeSelect']) ? form.values['modeSelect'].toString() : null;
        return {
            mode: selectValue,
        }
    }
    return {}
};

ConfigurationModeToggleForm.propTypes = {
    addField: PropTypes.bool,
    basePath: PropTypes.string,
    mode: PropTypes.string,
    submitOnEnter: PropTypes.bool,
};
ConfigurationModeToggleForm.defaultProps = {
    addField: true,
    mode: 'live',
    submitOnEnter: false,
};

const enhance = compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'modeForm',
        enableReinitialize: true,
    })
);

export default enhance(ConfigurationModeToggleForm);


// WEBPACK FOOTER //
// ./src/Fuse/components/ConfigurationModeToggleForm.js